module.exports = __webpack_public_path__ + "static/prepped-mobile-1-531c4d43323d49791595d2c8d7d2c954.jpg";